<template>
    <div id="news">
        <h1>Наши новости</h1>
        <table v-for="(rec, k) in news" :key="k" class="news_record">
            <td width="20%">
                <div :id="'carousel' + k" data-bs-interval="3000" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button v-for="(i_src, n) in rec[3]" :key="n" type="button" :data-bs-target="'#carousel'+k" :data-bs-slide-to="n"
                        :class="n == 0 ? 'active' : ''" :aria-current="n == 0 ? 'true' : 'false'" :aria-label="'Slide '+(n+1)"></button>
                    </div>
                    <div class="carousel-inner">
                        <div @click="sel_im = i_src" v-for="(i_src, n) in rec[3]" :key="n" :class="n == 0 ? 'carousel-item active' : 'carousel-item'">
                            <a href="#" @click="sel_im = i_src"><img :src="i_src" class="d-block w-100 news_img" alt="img"/></a>
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" :data-bs-target="'#carousel'+k"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Предыдущий</span>
                    </button>
                    <button class="carousel-control-next" type="button" :data-bs-target="'#carousel'+k"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Следующий</span>
                    </button>
                </div>
            </td>
            <td width="3%"></td>
            <td width="74%" style="vertical-align: top;">
                <h5>{{ rec[2] }}</h5>
                <h2><strong>{{ rec[0] }}</strong></h2>
                <h5 v-for="(a, n) in rec[1]" :key="n">{{ a }}</h5>
            </td>
            <td width="3%"></td>
        </table>
    </div>

    <div v-if="sel_im.length > 0" class="modal-lg modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel"
    role="dialog" style="display:block">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <img :src="sel_im" id="imagepreview" style="width: 100%;">
                </div>
                <div class="modal-footer">
                    <button @click="sel_im = ''" type="button" class="btn btn-default" data-dismiss="modal">Закрыть</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewsComp",
    data() {
        return {
            news: [],
            sel_im: ''
        }
    },
    mounted() {
        fetch("https://api.bormart.ru/get_news", {
            method: "GET",
            credentials: "include"
        }).then((response) => {
            return response.json()
        }).then((data) => {
            if (data["ok"] == 1) {
                this.news = data['news']
            }
        })
    }
}
</script>